import {Component, Input} from '@angular/core';
import {CmsListItemComponent} from "@kion/data-models";
import {CmsConfig} from "../../config/cms.config";

@Component({
  selector: 'kion-cms-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss']
})
export class ListItemComponent {

  @Input() component: CmsListItemComponent;

  project: string;

  constructor(private cmsConfig: CmsConfig) {
    this.project = cmsConfig.project;
  }
}
